import { render, staticRenderFns } from "./NumberProps.vue?vue&type=template&id=3daeb2e7"
import script from "./NumberProps.vue?vue&type=script&lang=js"
export * from "./NumberProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports